import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

// table(components)

// boostraps
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Badge, Button, Tabs, Tooltip } from "react-bootstrap";

// icons
import {
  AiFillEdit,
  AiOutlineBarChart,
  AiTwotoneAlert,
  AiTwotoneCalendar,
} from "react-icons/ai";

// sub form
import RadioResult from "./RadioResult";
// redux
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../features/UserActions";

import SqlSearchTypeA from "../components/SqlSearchTypeA";
import { EngDateFormatNoSplit } from "../../core/ThaiDate";

import SearchTypeB from "../components/SearchTypeB";
import { FcReadingEbook } from "react-icons/fc";
import CapturedImageViewer from "../technician/CapturedImageViewer";
import ScreenCapture from "../technician/ScreenCapture";
import SearchBrchGoodPopup from "../technician/SearchBrchGoodPopup";
import ConfirmDialog, { GetConfirmTitle } from "../components/ConfirmDialog";
import {
  ClearOldSession,
  EnumMessageType,
  EnumStudyID,
  GetDatePreriod,
  GetEnumValue,
} from "../../core/Helper";
import Loading from "../../components/Loading";
import MessageDialog from "../components/MessageDialog";
import { Cell, Legend, Pie, PieChart } from "recharts";
import { BiRefresh } from "react-icons/bi";
import { StudyService } from "../../model/study";
import { StudyMessageService } from "../../model/message-service";
import { encode } from "js-base64";
import { useNavigate } from "react-router-dom";
import DateRangeFilterBar from "../../components/DateRangeFilterBar";
import { GetCreateTable } from "../../core/Helper2";
import {
  BuildContextItem,
  IconName,
} from "../technician/TechWorklist_MenuPopup";
import { GetRadiWorkListColumn } from "./RadioWorklist_Columns";
import { TbReportSearch } from "react-icons/tb";
// import TemplateEditorSaveAs from './TemplateEditorSaveas';

export default function RadioWorklist() {
  const userDetail = useSelector((state) => state.user.detail);
  const scrollTop = useSelector((state) => state.scrollTrack.value.scTop);
  const scrollLeft = useSelector((state) => state.scrollTrack.value.scLeft);
  const theme = useSelector((s) => s.theme.theme);
  const dispatch = useDispatch();
  const [reqData, setReq] = useState([]);
  const [waitData, setWait] = useState([]);
  const [allData, setAllData] = useState([]);
  const [chart1, setChart1] = useState([
    { name: "เคสใหม่", value: 30 },
    { name: "ระหว่างวินิจฉัย", value: 10 },
    { name: "Finalized", value: 20 },
  ]);
  const [showCtx, setShowCtx] = useState(false);
  const [showEditor, setShowEditor] = useState({ show: false });
  const [showScreenCapture, setShowScreenCapture] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [refData, setRefData] = useState([]);
  const [captureResult, setCaptureResult] = useState(false);
  const [searchA, setSearchA] = useState({ show: false, action: () => {} });
  const [searchB, setSearchB] = useState({ show: false, action: () => {} });
  const [showImageView, setShowImageView] = useState(false);
  const [searchGood, setSearchGood] = useState({
    show: false,
    aciton: () => {},
  });
  const [updateFlag, setUpdateFlag] = useState(true);
  const [params, setParams] = useState({
    goodcateid: -1,
    gdmodid: -1,
    gdspecialtyid: -1,
    gdspcsubid: -1,
    custid: -1,
    custid_sender: -1,
    brchpatrightid: -1,
    price_list_id: -1,
  }); //* parameters สำหรับค้นหาสินค้าด้วย รหัสสินค้ากับรหัสสิทธิรักษา  **/
  const [searchParams, setSearchParams] = useState(null);
  const [dateRangeValues, changeDateRange] = useState([new Date(), new Date()]);
  // const [templateEditor, setTemplateEditor] = useState({show:false})

  const chargeColors = ["#fad530", "#0ba751", "#0c82f0", "#4d10f7"];
  // Confirm
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);

  const [table1, setTable1] = useState();
  const [table2, setTable2] = useState();
  const [table3, setTable3] = useState();

  // keep all context menu
  const [contextMenuList, setContextMenuList] = useState();

  // selectionMode
  const [ctxMode, setCtxMode] = useState("wait");
  const [dateSelected, setDateSelected] = useState(1);
  const [remainJob, setRemainJob] = useState(0);
  const [mouseXY, setMouseXY] = useState([0, 0]);

  const [msgBox, setMsgBox] = useState({
    show: false,
    title: "แจ้งเตือน",
    message: "ไม่พบข้อมูลคนไข้",
    type: EnumMessageType.ERROR,
  });

  //** Parameter from query string */
  // const queryParams = useLocation().search;
  // const id = new URLSearchParams(queryParams).get("aaa");

  const refMouse = useRef();

  const [loading, setLoading] = useState(false);

  // F
  const handleContextMenu = (e) => {
    if (selectedRow !== null) {
      setShowCtx(true);
    }
    e.preventDefault();
  };

  useEffect(() => {
    if (showEditor.show === false) {
      getData(true);
    }
  }, [dateRangeValues]);

  const navigate = useNavigate();

  // ---------------------------------------------------------------------
  useEffect(() => {
    if (showEditor.show === false) {
      document.addEventListener("contextmenu", handleContextMenu);
    } else {
      document.removeEventListener("contextmenu", handleContextMenu);
    }

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [showEditor, selectedRow]);
  // ---------------------------------------------------------------------
  useEffect(() => {
    if (updateFlag) {
      getData(true);
      setUpdateFlag(false);
    }
  }, [updateFlag]);
  // ---------------------------------------------------------------------

  useEffect(() => {
    const intervalId = setInterval(() => {
      console.log("interval working ....");
      // console.log(selectedRow);
      if (showEditor.show === false) {
        getData(false);
      }
    }, 60000);
    return () => {
      clearInterval(intervalId);
    };
  }, [showEditor, selectedRow, dateRangeValues]);

  // ** receive study components data {patient-right, }..
  useEffect(() => {
    getComponent();
  }, []);

  const getComponent = async () => {
    let ret = await StudyService.GetStudyComponents({
      BrchId: userDetail.brchid,
    });
    if (ret != null) {
      setRefData(ret);
    } else {
      remindError("Error loading study components");
    }
  };

  useEffect(() => {
    let counter = 0;
    for (let i = 0; i < allData.length; i++) {
      if (allData[i]?.diag_finish == "n") {
        counter++;
      }
    }
    setRemainJob(counter);
  }, [allData]);

  useEffect(() => {
    refMouse.current.style.left = `${scrollLeft + mouseXY[0] - 7}px`;
    refMouse.current.style.top = `${scrollTop + mouseXY[1] - 7}px`;
  }, [mouseXY]);

  const buildTable = (state, data) => {
    const getColumn = async () => {
      let cols = await GetRadiWorkListColumn();
      const [tb, setTb] = state;
      setTb(
        GetCreateTable({
          ...{
            idFieldName: "pacs_study_id",
            columns: cols,
            data: data,
          },
          ...{ selectRow, defaultSorted, rowEvents, defaultSorted },
        }),
      );
    };
    getColumn();
  };

  /** Build Menu-Context */
  const getContextItem = () => {
    let item = [
      {
        icon: IconName.RADI_ACCEPT_CASE,
        hidden: selectedRow?.rad_accepted === "y",
        onClick: () => actionAccept(selectedRow),
      },
      {
        icon: IconName.RADI_REJECT_CASE,
        hidden: selectedRow?.rad_accepted === "y",
        onClick: () => rejectStudy(),
      },
      {
        icon: IconName.RADI_DIAG_REPORT,
        hidden:
          selectedRow?.rad_accepted === "y" &&
          selectedRow?.rad_resulted === "y",
        onClick: () => showEditorAction(),
      },
      {
        icon: IconName.RADI_EDIT_REPORT,
        hidden: selectedRow?.diag_official === "n",
        onClick: () => showEditorAction(),
      },
      {
        icon: IconName.CANCEL_STUDY,
        hidden: selectedRow?.rad_accepted === "n",
        onClick: () => rejectStudy("ยืนยันการยกเลิกเคส"),
      },
      { icon: IconName.RETURN_NOACTION, onClick: () => setShowCtx(false) },
    ];
    return item;
  };

  useEffect(() => {
    const getMenu = async () => {
      let item = getContextItem();
      let ret = await BuildContextItem(item);
      setContextMenuList(ret);
    };
    getMenu();
    // return () => setContextMenuList(null);
  }, [selectedRow]);

  //** build table All-Study */
  useEffect(() => {
    if (ctxMode == "all") buildTable([table1, setTable1], allData);
    return () => {
      setTable1(null);
    };
  }, [allData, ctxMode]);
  // refMouse.current?.style?.top

  //** build table Request New incoming */
  useEffect(() => {
    if (ctxMode === "wait") {
      buildTable([table2, setTable2], reqData);
      return () => setTable2(null);
    }
  }, [reqData, ctxMode]);
  // refMouse.current?.style?.top

  //** build table in-diagnosis */
  useEffect(() => {
    if (ctxMode === "work") {
      buildTable([table3, setTable3], waitData);
      return () => setTable3(null);
    }
  }, [waitData, ctxMode]);
  //refMouse.current?.style?.top
  useEffect(() => {
    setPreriod("LAST7DAYS", 2);
  }, []);

  //--- Event สำหรับ เปิดภาพจากการคลิกที่ "tab การแจ้งเตือน"
  const openCaseFromNotifier = (e) => {
    getSingleStudy(e.detail.studyId, e.detail.messageId, (data) => {
      setSelectedRow(data.rows[0]);
      //** รับเคสแล้วไม่ต้องแจ้ง Admin อีก */
      if (data?.rows[0]?.rad_accepted === "n") {
        actionAccept(data.rows[0], () => {
          showEditorAction();
        });
      } else {
        showEditorAction();
      }
    });
  };

  //** event listener when clicked from notification slider */
  useEffect(() => {
    document.addEventListener("openStudyFromNotifyBox", openCaseFromNotifier);
    checkOpenStudyFromSession();
    return () => {
      document.removeEventListener(
        "openStudyFromNotifyBox",
        openCaseFromNotifier,
      );
    };
  }, []);

  //** เช็คการเปิดจาก app อื่น เช่น link ผ่านไลน์ */
  const checkOpenStudyFromSession = async () => {
    let pacsStudyId = sessionStorage.getItem("radconn_pacs_study_id");
    let radStaffId = sessionStorage.getItem("radconn_staff_id");
    let paramType = sessionStorage.getItem("radconn_param_type");
    let messageId = sessionStorage.getItem("message_id");

    if (messageId) {
      let ret = await StudyMessageService.CheckRadioValidMessage({
        MessageId: messageId,
        UserInfo: encode(JSON.stringify(userDetail)),
      });

      if (!ret.messageValid) {
        setMsgBox({
          show: true,
          title: "Invalid LINE Message",
          message: (
            <div style={{ color: "#f02906" }}>
              <div>ข้อความนี้ไม่มีผลใช้งานแล้ว</div>
              <div>กรุณาติดต่อแอดมิน</div>
              <div>จึงเรียนขออภัยมา ณ ที่นี้</div>
              <div>{ret?.studyInfo?.Radiologist?.FullFirstName}</div>
            </div>
          ),
          type: EnumMessageType.ERROR,
        });

        ClearOldSession();
        return;
      }
    }

    if (paramType === "radaction_accepted") {
      if (pacsStudyId && radStaffId) {
        if (userDetail.staffid == radStaffId) {
          getSingleStudy(pacsStudyId, messageId, (data) => {
            if (data != null) {
              setSelectedRow(data.rows[0]);
              //** รับเคสแล้วไม่ต้องแจ้ง Admin อีก */
              if (data?.rows[0]?.rad_accepted === "n") {
                actionAccept(data.rows[0], () => {
                  showEditorAction();
                });
              } else {
                showEditorAction();
              }
            }
          });
        }
      }
      ClearOldSession();
    }
    if (paramType === "admin_verify_case") {
      navigate("/home");
    }
  };

  // ---------------------------------------------------------------------
  const getData = async (showLoading) => {
    setLoading(showLoading);

    let ret = await StudyService.GetStudyListForRadi({
      UserInfo: userDetail,
      DateRange: [
        EngDateFormatNoSplit(dateRangeValues[0]),
        EngDateFormatNoSplit(dateRangeValues[1]),
      ],
      SearchInfo: searchParams,
    });

    if (ret != null) {
      setReq(ret.row_request);
      setWait(ret.row_wait);
      setAllData(ret.row_all);

      setChart1([
        { name: "เคสใหม่", value: ret.row_request.length || 0 },
        { name: "ระหว่างวินิจฉัย", value: ret.row_wait.length || 0 },
        {
          name: "Finalized",
          value:
            ret.row_all.length -
            ((ret.row_wait.length || 0) + (ret.row_request.length || 0)),
        },
      ]);
    } else {
      remindError("Study not found.");
    }
    setLoading(false);
  };
  //** Get Single Study */
  const getSingleStudy = async (pacsStudyId, messageId, callback) => {
    let ret = await StudyService.GetSingleStudyRadi({
      UserInfo: userDetail,
      StudyInfo: pacsStudyId,
      MessageId: messageId,
    });
    if (ret != null) {
      callback(ret);
    } else {
      callback(null);
      remindError({
        message: "ไม่สามารถเปิดเคสได้ เนื่องจากข้อความหมดอายุการใช้งาน",
      });
    }
  };
  // ---------------------------------------------------------------------
  const remindError = (msg) => {
    dispatch(setReminder({ show: true, message: msg.message, type: "error" }));
  };

  const defaultSorted = [
    {
      dataField: "action_dt",
      order: "desc",
    },
    {
      dataField: "action_dt2",
      order: "desc",
    },
  ];

  // --------------------------------------
  const showEditorAction = () => {
    // setShowEditor({
    //   show: false,
    //   action: () => {
    //     setShowEditor({ show: true });
    //     setShowCtx(false);
    //   },
    // });
    setShowEditor({ show: true });
    setShowCtx(false);
  };

  const confirmReceiveStatus = async (row) => {
    let ret = await StudyService.ComfirmAlreadyAccept({
      StudyInfo: row,
      UserInfo: userDetail,
    });
  };
  //** ยืนยันการรับเคส */
  const actionAccept = async (row, nextAction) => {
    setShowCtx(false);
    setLoading(true);

    let ret = await StudyService.UpdateStudyStatus({
      StudyInfo: row,
      StatusInfo: GetEnumValue(EnumStudyID, EnumStudyID.RAD_ACCEPTED),
      UserInfo: userDetail,
      MessageId: 0,
    });

    if (ret != null) {
      setUpdateFlag(true);
      setLoading(false);
      if (!nextAction) {
        //confirm การรับเคส
        confirmReceiveStatus(row);
        dispatch(
          setReminder({
            show: true,
            message: "ยืนยันการรับเคสแล้ว",
            type: "success",
          }),
        );
      } else {
        nextAction();
      }
    } else {
      setLoading(false);
      dispatch(
        setReminder({
          show: true,
          message: "ไม่สามารถยืนยันการับเคสได้",
          type: "error",
        }),
      );
    }
  };

  //** ปฏิเสธเคส */ --------------------------------------
  const rejectStudy = (message) => {
    setShowCtx(false);
    setShowConfirm(true);
    setConfirmAction({
      title: message ?? GetConfirmTitle("REJECT_CASE"),
      data: selectedRow,
      action: async (row) => {
        let ret = await StudyService.UpdateStudyStatus({
          StudyInfo: row,
          StatusInfo: GetEnumValue(EnumStudyID, EnumStudyID.RAD_REJECTED),
          UserInfo: userDetail,
        });
        if (ret != null) {
          setUpdateFlag(true);
          dispatch(
            setReminder({
              show: true,
              message: "ยืนยันการปฏิเสธเคสแล้ว",
              type: "success",
            }),
          );
        } else {
          dispatch(
            setReminder({
              show: true,
              message: ret?.message,
              type: "error",
            }),
          );
        }
      },
    });
  };

  const UpdateMouseCursor = (e) => {
    if (e.clientX) {
      setMouseXY([e.clientX, e.clientY]);
    }
  };

  const UpdateSelectedRow = (row) => {
    setSelectedRow(row);
  };

  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    classes: "row-h-over-selected",
    hideSelectColumn: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      UpdateMouseCursor(e);
      UpdateSelectedRow(row);
    },
  };
  // --------------------------------------
  const AutoAcceptCase = (row) => {
    confirmReceiveStatus(row);
    if (selectedRow?.rad_accepted === "n") {
      actionAccept(row ?? selectedRow, () => {
        showEditorAction();
      });
    } else {
      showEditorAction();
    }
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      UpdateMouseCursor(e);
      UpdateSelectedRow(row);
    },
    onDoubleClick: (e, row, rowIndex) => {
      AutoAcceptCase(row);
    },
    onMouseEnter: (e, row, rowIndex) => {
      setShowCtx(false);
      UpdateSelectedRow(row);
      UpdateMouseCursor(e);
    },
    onMouseMove: (e, row, rowIndex) => {
      refMouse.current.style.left = `${e.clientX - 7}px`;
    },
    onMouseDown: (e, row, rowIndex) => {
      UpdateMouseCursor(e);
    },
  };

  const setPreriod = (dateStyle, index) => {
    changeDateRange(GetDatePreriod(dateStyle));
    setDateSelected(index);
  };

  // setwidth={window.screen.width}
  // const[key, setKey] = useState('wait');

  return (
    <div>
      {loading ? <Loading /> : <></>}

      <OverlayTrigger
        show={showCtx}
        placement="right"
        // overlay={ctxMode !== "all" ? contextMenuList : <></>}
        overlay={contextMenuList}
      >
        <MotionBox ref={refMouse} />
      </OverlayTrigger>

      <div className="page-title-header">
        <TbReportSearch
          style={{
            color: "#12ddf4",
            marginRight: "15px",
            height: "30px",
            width: "30px",
          }}
        />
        {"Radiologist Work-List"}
      </div>
      {/* ---------------------------------------------------------------------------------------- */}
      <HBox>
        <VBox>
          <HBox>
            <DateRangeFilterBar
              {...{ dateRange: [dateRangeValues, changeDateRange] }}
            />

            <HBox style={{ flex: "1", color: "#81ecb9", padding: "5px" }}>
              <div>
                <OverlayTrigger
                  placement="top"
                  overlay={(props) => <Tooltip {...props}>Refresh</Tooltip>}
                >
                  <Button
                    variant={theme.themeName}
                    style={{
                      flex: "1",
                      borderRadius: "60px",
                    }}
                    onClick={() => {
                      getData(true);
                    }}
                  >
                    <BiRefresh
                      color={theme.themeName === "dark" ? "#09f829" : "#0000ff"}
                      size={30}
                    />
                  </Button>
                </OverlayTrigger>
              </div>
            </HBox>
          </HBox>
        </VBox>
      </HBox>
      {/* ---------------------------------------------------------------------------------------- */}

      <Tabs
        style={{
          background: "var(--bg-primary)",
          marginTop: "3px",
          paddingTop: "10px",
        }}
        id="controlled-tab-example"
        activeKey={ctxMode}
        className="mb-2"
        variant="tabs"
        onSelect={(e) => {
          /**set 'wait' or 'diag' */
          setSelectedRow(null);
          setCtxMode(e);
        }}
        justify
      >
        <TabDiv
          eventKey="all"
          title={
            <span>
              <AiTwotoneCalendar color="#13eb42" size={18} />
              All Status <span style={{ color: "#07d623" }}>|</span>
              {" Unfinalized"}
              <Badge bg="danger" style={styles.badgeInner}>
                {remainJob}
              </Badge>
              {""}
            </span>
          }
        >
          {table1}
        </TabDiv>

        <TabDiv
          eventKey="wait"
          title={
            <span>
              <AiTwotoneAlert color="#13eb42" size={18} />
              เคสใหม่
              <Badge bg="warning" color="#d6b707" style={styles.badgeInner}>
                {reqData.length}
              </Badge>
            </span>
          }
        >
          <MainBox>
            {table2}

            <RadioResult
              {...{
                editor: [showEditor, setShowEditor],
                userDetail,
                selectedRow: [selectedRow, setSelectedRow],
                showCtx: [showCtx, setShowCtx],
                refData,
                showScreenCapture,
                setShowScreenCapture,
                searchState: [searchA, setSearchA],
                showImage: [showImageView, setShowImageView],
                searchGood: [searchGood, setSearchGood],
                searchB: [searchB, setSearchB],
                params: [params, setParams],
                updateFlag: [updateFlag, setUpdateFlag],
                enableSave: true,
                enablePrint: false,
                loading: [loading, setLoading],
                // template:[templateEditor, setTemplateEditor]
              }}
            />

            <ScreenCapture
              {...{
                showScreenCapture,
                setShowScreenCapture,
                userDetail,
                selectedRow,
                setCaptureResult,
              }}
            ></ScreenCapture>
            <SqlSearchTypeA {...{ winState: [searchA, setSearchA] }} />
            <SearchTypeB {...{ winState: [searchB, setSearchB] }} />

            <CapturedImageViewer
              {...{ showImage: [showImageView, setShowImageView] }}
            />
            <SearchBrchGoodPopup
              {...{
                winState: [searchGood, setSearchGood],
                params: [params, setParams],
              }}
            />
          </MainBox>
        </TabDiv>

        <TabDiv
          eventKey="work"
          title={
            <span>
              <AiFillEdit color="#13eb42" size={18} />
              ระหว่างวินิจฉัยผล
              <Badge bg="success" style={styles.badgeInner}>
                {waitData.length}
              </Badge>
            </span>
          }
        >
          {table3}
        </TabDiv>
        <TabDiv
          eventKey="summary"
          title={
            <span>
              <AiOutlineBarChart color="#13eb42" size={18} />
              Summary
            </span>
          }
        >
          <div
            style={{
              flex: "1",
              justifyContent: "center",
              display: "flex",
              // background: "red",
              paddingBlock: "50px",
              alignItems: "center",
            }}
          >
            <PieChart width={600} height={400}>
              <Pie
                data={chart1}
                dataKey="value"
                innerRadius={10}
                outerRadius={150}
                fill="#8884d8"
                label
              >
                {chart1.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={chargeColors[index % chargeColors.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend layout="vertical" verticalAlign="middle" align="right" />
            </PieChart>
          </div>
        </TabDiv>
      </Tabs>

      {/* <TemplateEditorSaveAs {...{winState:[templateEditor, setTemplateEditor]}} />  */}
      <ConfirmDialog
        {...{ showConfirm, setShowConfirm, confirmAction, setConfirmAction }}
      />

      <MessageDialog
        {...{
          param: [msgBox, setMsgBox],
        }}
      />
    </div>
  );
}

const MainBox = styled.div`
  min-width: ${(props) => props.win_width}px;
  /* height: 100vh; */
  /* overflow-x: scroll; */
`;

const MotionBox = styled.div`
  position: absolute;
  top: 100px;
  left: 100px;
  height: 15px;
  width: 15px;
  background-color: transparent;
  //background-color: aliceblue;

  z-index: -10;
`;

const HBox = styled.div`
  display: flex;
`;

const VBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const SBox = styled.div`
  color: white;
  margin: 5px;
  flex: 1;
`;

const styles = {
  icon: { color: "#2731ff", marginRight: "5px", width: "30px", height: "30px" },
  listItem: { color: "#fb4204" },
  badgeInner: { marginLeft: "10px" },
};

const TabDiv = styled("Tabs")`
  color: "white";
`;
